const ITEMS = ["SOLAMOVE", "EVERY STEP MAKES YOU STRONGER", "PRÉ-LANCEMENT 2026", "ET SI CHAQUE PAS COMPTAIT DAVANTAGE ?"];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-[#0D0D0D]" : "border-black/[0.08] bg-white"}`}
    >
      <div className="animate-marquee-slow flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display uppercase tracking-[0.25em] text-sm px-10 ${dark ? "text-[#FAF8F5]/70" : "text-[#0D0D0D]/70"}`}>
                  {item}
                </span>
                <span className={`h-1.5 w-1.5 rounded-full ${i % 3 === 0 ? "bg-[#CBD5C0]" : i % 3 === 1 ? "bg-[#E6CECA]" : "bg-[#D9CFC2]"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
